export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '25-39',
              value: 1,
              selected: false
            },
            {
              label: '40-49',
              value: 2,
              selected: false
            },
            {
              label: '50-75',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Employer Size',
          code: 'employer_size',
          multi: true,
          options: [
            {
              label: '1 - 9',
              value: 1,
              selected: false
            },
            {
              label: '10 - 99',
              value: 2,
              selected: false
            },
            {
              label: '100 - 499',
              value: 3,
              selected: false
            },
            {
              label: '500 - 999',
              value: 4,
              selected: false
            },
            {
              label: '1,000 - 4,999',
              value: 5,
              selected: false
            },
            {
              label: '5,000+',
              value: 6,
              selected: false
            }
          ]
        },
        {
          label: 'Industry',
          // excludeFromVerbatims: true,
          code: 'industry',
          multi: true,
          options: [
            {
              label: 'Targeted Industries',
              value: 1,
              selected: false
            },
            {
              label: 'Non-Targeted Industries',
              value: 2,
              selected: false
            },
            {
              label: 'Public Sector',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Role',
          code: 'role',
          multi: true,
          options: [
            {
              label: 'Internet DM',
              value: 1,
              selected: false
            },
            {
              label: 'Business DM',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Title',
          code: 'title',
          multi: true,
          options: [
            {
              label: 'Business Owner/C-Suite',
              value: 1,
              selected: false
            },
            {
              label: 'Exec/VP/Director',
              value: 2,
              selected: false
            },
            {
              label: 'Manager/Supervisor',
              value: 3,
              selected: false
            },
            {
              label: 'Other',
              value: 4,
              selected: false
            }
          ]
        },
        {
          label: 'TfB Customers',
          code: 'tfb_customer',
          multi: true,
          options: [
            {
              label: 'Customer',
              value: 1,
              selected: false
            },
            {
              label: 'Prospect',
              value: 2,
              selected: false
            }
          ]
        }
      ]

    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/components/scorecard/ScorecardView/ScorecardFilter/index.js